// const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
// const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
// const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
// const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// // Scroll in animation logic
// function onIntersection(elements, observer) {
//   elements.forEach((element, index) => {
//     if (element.isIntersecting) {
//       const elementTarget = element.target;
//       if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
//         elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
//         if (elementTarget.hasAttribute('data-cascade'))
//           elementTarget.setAttribute('style', `--animation-order: ${index};`);
//       }
//       observer.unobserve(elementTarget);
//     } else {
//       element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
//       element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
//     }
//   });
// }

// function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
//   const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
//   if (animationTriggerElements.length === 0) return;

//   if (isDesignModeEvent) {
//     animationTriggerElements.forEach((element) => {
//       element.classList.add('scroll-trigger--design-mode');
//     });
//     return;
//   }

//   const observer = new IntersectionObserver(onIntersection, {
//     rootMargin: '0px 0px -50px 0px',
//   });
//   animationTriggerElements.forEach((element) => observer.observe(element));
// }

// // Zoom in animation logic
// function initializeScrollZoomAnimationTrigger() {
//   if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

//   const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

//   if (animationTriggerElements.length === 0) return;

//   const scaleAmount = 0.3 / 100;

//   animationTriggerElements.forEach((element) => {
//     let elementIsVisible = false;
//     const observer = new IntersectionObserver((elements) => {
//       elements.forEach((entry) => {
//         elementIsVisible = entry.isIntersecting;
//       });
//     });
//     observer.observe(element);

//     element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

//     window.addEventListener(
//       'scroll',
//       throttle(() => {
//         if (!elementIsVisible) return;

//         element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
//       }),
//       { passive: true }
//     );
//   });
// }

// function percentageSeen(element) {
//   const viewportHeight = window.innerHeight;
//   const scrollY = window.scrollY;
//   const elementPositionY = element.getBoundingClientRect().top + scrollY;
//   const elementHeight = element.offsetHeight;

//   if (elementPositionY > scrollY + viewportHeight) {
//     // If we haven't reached the image yet
//     return 0;
//   } else if (elementPositionY + elementHeight < scrollY) {
//     // If we've completely scrolled past the image
//     return 100;
//   }

//   // When the image is in the viewport
//   const distance = scrollY + viewportHeight - elementPositionY;
//   let percentage = distance / ((viewportHeight + elementHeight) / 100);
//   return Math.round(percentage);
// }

// window.addEventListener('DOMContentLoaded', () => {
//   initializeScrollAnimationTrigger();
//   initializeScrollZoomAnimationTrigger();
// });

// if (Shopify.designMode) {
//   document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
//   document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
// }


function initializeScrollZoomAnimationTrigger() {
  // Run this animation only on desktop (>= 990px)
  if (window.innerWidth < 990) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const zoomTargets = Array.from(document.getElementsByClassName('animate--zoom-in'));
  if (!zoomTargets.length) return;

  const MAX_SCALE = 1.25; // how much it zooms
  const MAX_SHIFT_X = 120; // px move toward right (adjust if needed)

  function getProgressFromBanner(element) {
    const banner = element.closest('section, .banner, .hero') || element;
    const rect = banner.getBoundingClientRect();
    const vh = window.innerHeight;

    let progress = (vh - rect.top) / (vh + rect.height);
    return Math.min(1, Math.max(0, progress));
  }

  function updateZoom() {
    zoomTargets.forEach((target) => {
      const progress = getProgressFromBanner(target);

      const scale = 1 + (MAX_SCALE - 1) * progress;
      const translateX = MAX_SHIFT_X * progress;

      const container =
        target.closest('[class*="banner"], [class*="hero"], section, div') ||
        target.parentElement;

      if (!container) return;

      const images = container.querySelectorAll('img');
      if (!images.length) return;

      // lock width to first image (prevents mismatch)
      const baseWidth = images[0].getBoundingClientRect().width;

      images.forEach((img) => {
        img.style.width = `${baseWidth}px`;
        img.style.maxWidth = 'none';
        img.style.height = 'auto';
        img.style.transformOrigin = 'right center';
        img.style.willChange = 'transform';
        img.style.transform = `translateX(${translateX}px) scale(${scale})`;
      });
    });
  }

  let ticking = false;
  function onScroll() {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateZoom();
        ticking = false;
      });
      ticking = true;
    }
  }

  updateZoom();
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', updateZoom);
}

// Only initialize on desktop, and tear down if resizing below 990px.
(function () {
  let initialized = false;
  let lastWidthWasDesktop = window.innerWidth >= 990;

  function initIfNeeded() {
    const isDesktop = window.innerWidth >= 990;
    if (!isDesktop) return;
    if (initialized) return;
    initialized = true;
    initializeScrollZoomAnimationTrigger();
  }

  function onResize() {
    const isDesktop = window.innerWidth >= 990;
    if (isDesktop && !lastWidthWasDesktop) {
      // Entering desktop: initialize
      initialized = false;
      initIfNeeded();
    }
    lastWidthWasDesktop = isDesktop;
  }

  window.addEventListener('DOMContentLoaded', initIfNeeded);
  window.addEventListener('resize', onResize);
})();
